import { useQuery } from "@tanstack/react-query";
import api from "../../../../../services/api";
import { UploadSourcesList } from "../@types/UploadSource";

const useConnectorsData = (hashValue: string, limit?: number) => {
  const { data, isLoading, isError, isSuccess } = useQuery({
    queryKey: ["connectorsData", hashValue, limit],
    queryFn: async () => {
      try {
        return await api.connectorsData(hashValue, limit);
      } catch (err) {
        console.error("connectors-data request failed:", err);
        throw err;
      }
    },
    enabled: Boolean(hashValue),
    refetchInterval: 60_000,
    select: response => ({
      connectors: (response.data.connectors_data || []) as UploadSourcesList,
      totalCount: (response.data.total_count ?? 0) as number
    })
  });

  return {
    data: data?.connectors ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isError,
    // `totalCount` defaults to 0, so it cannot tell "resolved with no rows" from "no answer yet".
    // Callers that act on emptiness need this: it is only true once a response has arrived.
    isSuccess
  };
};

export default useConnectorsData;
